export var loadJsUrl = {
  wx: 'https://res.wx.qq.com/open/js/jweixin-1.2.0.js',
  qywx: 'https://open.work.weixin.qq.com/wwopen/js/jwxwork-1.0.0.js',
  dingTalk: 'https://g.alicdn.com/dingding/dingtalk-jsapi/2.13.42/dingtalk.open.js',
  fs: ''
};